export const isInactive = (profile) => {
  return profile && profile.status === "INACTIVE";
};

export const isWaitListed = (profile) => {
  return profile?.is_wait_listed === true;
};

export const hasAcknowledgedHCPDI = (profile) => {
  return profile?.acknowledgements?.hcp_di_reminder ?? false;
};

export const shouldShowHCPDIModal = (profile) => {
  return (
    profile &&
    profile.group_type === "hcp_program" &&
    profile.schedule_video_call &&
    !hasAcknowledgedHCPDI(profile) &&
    !isInactive(profile)
  );
};

export const shouldShowInactiveModal = (profile) => {
  return isInactive(profile);
};

export const shouldShowWaitListModal = (profile) => {
  return isWaitListed(profile);
};

export const shouldShowFamilyMembersWidget = (profile) => {
  return !!(
    (profile?.enriched_associated_wards ?? []).length ||
    (profile?.enriched_associated_guardians ?? []).length
  );
};
